export default __webpack_public_path__ + "static/poker-5ec9d97764132b908a8e67960f05c231.png";